import ClientPortal from '../../plugins/axios'

export default async function authAdmin({ next, to }) {
    try {
        // Check if route contains admin
        if (to.path.includes('/admin')) {
            console.log('admin route')
            const response = await ClientPortal.get( `${process.env.VUE_APP_API}/admin` )

            if (response.status === 200) {
                return next()
            }

            return next('/404')
        } else {
            return next()
        }

    } catch (error) {
        console.error('Admin authentication failed:', error)
        return next('/404')
    }
}
